/** Modes de session considérés comme une alerte (média visible, couleur rouge…). */
export function isAlertSessionType(sessionType) {
    const alertModes = ["ALERT", "LIVEMAPALERTE", "MANUAL", "SHORTCUT", "WIDGET", "SHAKE_DETECTED", "ACCIDENT_DETECTED", "ITINERARY_STOPPED", "ITINERARY_OUT_OF_ZONE", "LIVE_SHARE_STOPPED"];
    return alertModes.includes(String(sessionType || '').toUpperCase());
}

// Les options média peuvent être armées pendant un partage de position.
// Elles ne deviennent visibles/actives dans le viewer qu'une fois l'alerte déclenchée.
export function getAlertMediaType(sessionType, { audio = false, video = false, mediaType = 'gps' } = {}) {
    if (!isAlertSessionType(sessionType)) return 'gps';
    if (video) return 'video';
    if (audio) return 'audio';
    return ['audio', 'video'].includes(mediaType) ? mediaType : 'gps';
}
